module.exports = __webpack_public_path__ + "img/547373f.webp";